import React, { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import get from 'lodash.get';
import arrayMutators from 'final-form-arrays';

// @ts-ignore
import { selectActiveTableCellRowIds } from 'services/selectedTableCells/selectors';
import {
    VirtualizedTableItem,
    VirtualizedTableItemKey
} from 'services/virtualizedTable/types';
import { setItemsValue } from 'services/virtualizedTable/actions';

import VirtualizedTableBulkEditForm from '../VirtualizedTableBulkEditForm';
import VirtualizedTableContext from '../VirtualizedTableContext';
import { VirtualizedTableContextProviderValue } from '../../types';

interface Props {
    onClose: () => void;
}

export const VirtualizedTableBulkEditFormWrapperComponent = (
    props: Props
): React.ReactElement => {
    const dispatch = useDispatch();

    const { onClose } = props;

    const activeItemKeys: VirtualizedTableItemKey[] = useSelector(
        selectActiveTableCellRowIds
    );

    const {
        onItemsValueChange
    }: VirtualizedTableContextProviderValue = useContext(
        VirtualizedTableContext
    );

    const handleSubmit = (values: VirtualizedTableItem): void => {
        const { columnKey } = values;
        const itemValue = get(values, columnKey);

        /**
         * Update items in state
         */
        dispatch(setItemsValue(activeItemKeys, columnKey, itemValue));

        /**
         * Comunicate that items have changed.
         */
        if (onItemsValueChange) {
            onItemsValueChange(activeItemKeys, columnKey, itemValue);
        }

        onClose();
    };

    return (
        <FinalForm
            onSubmit={handleSubmit}
            mutators={{
                ...arrayMutators
            }}
            render={VirtualizedTableBulkEditForm}
            subscription={{}}
            keepDirtyOnReinitialize
        />
    );
};

export default VirtualizedTableBulkEditFormWrapperComponent;
